import { Factory } from 'rosie';

Factory.define('AgentRoutingPreferences')
  .attr('channels', {})
  .attr('_version', 1);

Factory.define('AgentRoutingPreferencesNone')
  .extend('AgentRoutingPreferences')
  .attr('channels', () => Factory.attributes('ChannelStatesNone'));

Factory.define('ChannelStatesNone')
  .attr('MAIL', false)
  .attr('MESSAGING', false)
  .attr('TASK', false)
  .attr('VOICE', false);



// WEBPACK FOOTER //
// ./factories/agent_routing_preferences_factory.js